import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, } from '@doxyme/ui';
import operations from '../operations';
import './confirm-dialog.scss';
const defaultButtonProps = {
    color: 'primary',
    btnStyle: 'solid',
    size: 'medium',
};
export const ConfirmDialog = ({ onConfirm, captions, styles = {}, }) => {
    const { header, content, confirm } = captions;
    const { confirmButton = defaultButtonProps } = styles;
    const onClose = () => {
        operations.hide();
    };
    return (<Modal className="confirm-dialog" closeModal={onClose} isOpen closeOnOutsideClick>
      <ModalHeader onClose={onClose}>
        <h4>
          <FormattedMessage id={header.id} values={{ ...header.value }}/>
        </h4>
      </ModalHeader>

      <ModalBody>
        <FormattedMessage id={content.id} values={{ ...content.value }}/>
      </ModalBody>

      <ModalFooter>
        <Button btnStyle="outline" size="medium" onClick={onClose}>
          <FormattedMessage id="common.cancel"/>
        </Button>

        <Button onClick={onConfirm} size={confirmButton.size} color={confirmButton.color} btnStyle={confirmButton.btnStyle}>
          <FormattedMessage id={confirm.id} values={{ ...confirm.value }}/>
        </Button>
      </ModalFooter>
    </Modal>);
};
